import { DOCUMENT } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  inject,
  signal,
} from '@angular/core';
import {
  RdsIconButtonComponent,
  RdsIconComponent,
} from '@rds/angular-components';

import { RoomQueryParams, ViewportService } from '@bookly/shared';

import { RoomsService } from '../../services/rooms.service';
import { FilterFormComponent } from '../room-filters-form/filter-form.component';

@Component({
  selector: 'bus-room-filters-menu',
  imports: [RdsIconComponent, FilterFormComponent, RdsIconButtonComponent],
  templateUrl: './room-filters-menu.component.html',
  styleUrl: './room-filters-menu.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RoomFiltersMenuComponent {
  readonly #roomService = inject(RoomsService);
  readonly #document = inject(DOCUMENT);
  protected readonly isMobileScreen = inject(ViewportService).isMobile;

  protected showHideClass = signal<'show' | 'hide'>('hide');

  public hideMenu() {
    this.showHideClass.set('hide');
  }

  public showMenu() {
    this.showHideClass.set('show');
  }

  protected applyFilters(filters: RoomQueryParams) {
    this.hideMenu();
    this.#document
      .querySelector<HTMLElement>('.main-panel main')
      ?.scrollTo({ top: 0, behavior: 'smooth' });
    this.#roomService.getRooms(filters).subscribe();
  }
}
